/**
 * Created by kongwm.kong on 2017/7/31.
 * 表单的下拉列表的静态值
 */
const list = {
  /*产品下拉框*/
  selectList: [ //运行状态----
    {id: 1, 'title': '募集中'},
    {id: 2, 'title': '开放运行'},
    {id: 3, 'title': '封闭运行'},
    {id: 4, 'title': '提前清算'},
    {id: 5, 'title': '到期清算'},
    {id: 6, 'title': '发行失败'}
  ],
  durationList: [/*续存期---*/
    {id: -1, 'title': '不确定'},
    {id: 0, 'title': '无固定期限'},
    {id: 999999, 'title': '永续'}
  ],
  innerBackList: [   //认购费是否内扣----
    {id: 1, 'title': '是'},
    {id: 0, 'title': '否'},
    {id: -1, 'title': '未知'}
  ],
  navFrequencyList: [/*净值披露周期----保留争议*/
    {id: 1, 'title': '天'},
    {id: 2, 'title': '周'},
    {id: 3, 'title': '月'},
    {id: 4, 'title': '季'},
    {id: 5, 'title': '半年'}
  ],
  baseCurrencyList: [/*基础货币---*/
    {id: 1, 'title': '人民币'},
    {id: 2, 'title': '港币'},
    {id: 3, 'title': '美元'},
    {id: 4, 'title': '份'},
    {id: -1, 'title': '其他'},
  ],
  performanceFeesFormList: [/*业绩报酬计提形式*/
    {id: 1, 'title': '份额提记'},
    {id: 2, 'title': '净值提记'}
  ],
  simuCelueIdList: [/*投资策略----*/
    {id: 2010000, 'ptitle': '主观股票'},
    {id: 2010100, 'ptitle': '主观股票-深度价值'},
    {id: 2010200, 'ptitle': '主观股票-价值成长'},
    {id: 2010300, 'ptitle': '主观股票-成长'},
    {id: 2010400, 'ptitle': '主观股票-基本面趋势'},
    {id: 2010500, 'ptitle': '主观股票-其他'},
    {id: 2020000, 'ptitle': '量化股票'},
    {id: 2020100, 'ptitle': '量化股票-量化选股'},
    {id: 2020200, 'ptitle': '量化股票-指数增强'},
    {id: 2020201, 'ptitle': '量化股票-指数增强-沪深300指增'},
    {id: 2020202, 'ptitle': '量化股票-指数增强-中证500指增'},
    {id: 2020203, 'ptitle': '量化股票-指数增强-中证A500指增'},
    {id: 2020204, 'ptitle': '量化股票-指数增强-中证1000指增'},
    {id: 2020205, 'ptitle': '量化股票-指数增强-中证2000指增'},
    {id: 2020206, 'ptitle': '量化股票-指数增强-国证2000指增'},
    {id: 2020207, 'ptitle': '量化股票-指数增强-万得小市值指增'},
    {id: 2020208, 'ptitle': '量化股票-指数增强-其他指数增强'},
    {id: 2020300, 'ptitle': '量化股票-量化择时'},
    {id: 2030000, 'ptitle': '股票对冲'},
    {id: 2030100, 'ptitle': '股票对冲-股票中性'},
    {id: 2030200, 'ptitle': '股票对冲-混合中性'},
    {id: 2030300, 'ptitle': '股票对冲-灵活对冲'},
    {id: 2030400, 'ptitle': '股票对冲-股票多空'},
    {id: 2040000, 'ptitle': '期货'},
    {id: 2040100, 'ptitle': '期货-量化CTA'},
    {id: 2040200, 'ptitle': '期货-主观CTA'},
    {id: 2040300, 'ptitle': '期货-商品套利'},
    {id: 2040400, 'ptitle': '期货-期权策略'},
    {id: 2050000, 'ptitle': '债券策略'},
    {id: 2050100, 'ptitle': '债券策略-纯债策略'},
    {id: 2050200, 'ptitle': '债券策略-债券复合'},
    {id: 2050300, 'ptitle': '债券策略-可转债策略'},
    {id: 2050301, 'ptitle': '债券策略-可转债策略-量化'},
    {id: 2050302, 'ptitle': '债券策略-可转债策略-主观'},
    {id: 2050400, 'ptitle': '债券策略-可交债策略'},
    {id: 2060000, 'ptitle': '多资产策略'},
    {id: 2060100, 'ptitle': '多资产策略-宏观对冲'},
    {id: 2060200, 'ptitle': '多资产策略-其他套利'},
    {id: 2060300, 'ptitle': '多资产策略-复合策略'},
    {id: 2070000, 'ptitle': '组合策略'},
    {id: 2070100, 'ptitle': '组合策略-FOF'},
    {id: 2070200, 'ptitle': '组合策略-MOM'},
    {id: 2080000, 'ptitle': '另类策略'},
    {id: 2080100, 'ptitle': '另类策略-打板策略'},
    {id: 2080200, 'ptitle': '另类策略-其他'}
  ],
  substrategyList: [
    {id: 1, 'title': '股票多头'},
    {id: 2, 'title': '股票多/空'},
    {id: 3, 'title': '股票量化'},
    {id: 4, 'title': '股票行业策略'},
    {id: 5, 'title': '股票复合策略'},
    {id: 6, 'title': '宏观策略'},
    {id: 7, 'title': '趋势交易'},
    {id: 8, 'title': '日内交易'},
    {id: 9, 'title': '波段交易'},
    {id: 10, 'title': '高频交易'},
    {id: 11, 'title': '管理期货复合策略'},
    {id: 12, 'title': '并购重组'},
    {id: 13, 'title': '定向增发'},
    {id: 14, 'title': '大宗交易'},
    {id: 15, 'title': '事件驱动复合策略'},
    {id: 16, 'title': '股票市场中性'},
    {id: 17, 'title': '套利'},
    {id: 21, 'title': '相对价值复策略'},
    {id: 22, 'title': '债券策略'},
    {id: 27, 'title': 'MOM'},
    {id: 28, 'title': 'FOF'},
    {id: 24, 'title': '复合策略'},
    {id: 25, 'title': '系统化趋势'},
    {id: 26, 'title': '系统化套利'},
    {id: -1, 'title': '其他策略'}
  ], //子策略   根据投资策略变化
  fundPrdTypeList: [/*产品发行类型----*/
    {id: 1, 'title': '信托'},
    {id: 2, 'title': '有限合伙'},
    {id: 3, 'title': '券商资管'},
    {id: 4, 'title': '公募专户'},
    {id: 5, 'title': '单账户'},
    {id: 6, 'title': '自主发行'},
    {id: 7, 'title': '海外基金'},
    {id: 8, 'title': '期货专户'},
    {id: -1, 'title': '其他'}
  ],
  investmentAreaList: [/*投资区域---*/
    {id: 0, 'title': '境内'},
    {id: 1, 'title': '境外'}
  ],
  /*公司*/
  privateOffshoreFundList: [  //是否有海外资金---
    {id: 0, 'title': '否'},
    {id: 1, 'title': '是'},
    {id: -1, 'title': '其他'}
  ],
  //管理基金主要类别----测试变
  mainBusinessList: [
    {id: 1, 'title': '证券投资基金'},
    {id: 2, 'title': '其他投资基金'},
    {id: 3, 'title': '股权、创业投资基金'}
  ],
  /*公司列表*/
  companyNatureList: [  //企业性质  对应 公司类型----
    {id: 1, 'title': '私募投资管理公司'},
    {id: 2, 'title': '公募基金公司'},
    {id: 3, 'title': '银行'},
    {id: 4, 'title': '证券公司'},
    {id: 5, 'title': '信托公司'},
    {id: 6, 'title': '审计机构'},
    {id: 7, 'title': '法律顾问'},
    {id: 8, 'title': '投资顾问'},
    {id: 9, 'title': '行政管理人'},
    {id: 10, 'title': '上市公司'},
    {id: 11, 'title': '期货公司'},
    {id: 12, 'title': '工作室'},
    {id: 13, 'title': '证券公司子公司'},
    {id: 14, 'title': '期货公司子公司'},
    {id: -1, title: '其他'}
  ],
  privateCompanyStatusList: [ //公司状态---
    {id: 1, 'title': '运行'},
    {id: 2, 'title': '注销'}
  ],
  manageScaleStartList: [/*公司规模---*/
    {id: 1, 'title': '0-1亿'},
    {id: 2, 'title': '1-10亿'},
    {id: 3, 'title': '10-20亿'},
    {id: 4, 'title': '20-50亿'},
    {id: 5, 'title': '50-100亿'},
    {id: 6, 'title': '100亿以上'}
  ],
  manageScaleEndList: [/*货币单位----*/
    {id: 1, 'title': '人民币'},
    {id: 2, 'title': '港币'},
    {id: 3, 'title': '美元'},
    {id: -1, title: '其他'}
  ],
  privateBaseCurrencyUnitList: [ //注册资本


  ],
  regCapitalStartList: [],
  paidCapitalStartList: [ //实缴资本

  ],
  paidCapitalEndList: [//实缴资本 单位哦

  ],

  sexList: [  //性别----
    {id: 1, 'title': '男'},
    {id: 2, 'title': '女'},
    {id: 0, 'title': '不详'}
  ],
  educationList: [ //最高学历---
    {id: 4, 'title': '本科'},
    {id: 1, 'title': '小学'},
    {id: 2, 'title': '中学'},
    {id: 3, 'title': '大专'},
    {id: 5, 'title': '硕士'},
    {id: 6, 'title': '博士'},
    {id: 7, 'title': '博士后'}
  ],
  backgroundList: [  //履历背景---
    {id: 1, 'title': '券商'},
    {id: 2, 'title': '公募'},
    {id: 3, 'title': '其他金融机构'},
    {id: 4, 'title': '媒体'},
    {id: 5, 'title': '海外'},
    {id: 6, 'title': '民间'},
    {id: 7, 'title': '期货'},
    {id: 8, 'title': '实业'},
    {id: 9, 'title': '学者'},
    {id: 10, 'title': '银行'},
    {id: 11, 'title': '信托'},
    {id: 12, 'title': '保险'},
    {id: 13, 'title': '私募'},
    {id: -1, 'title': '其他'}
  ],
  /*职位类别---*/
  personnelTypeList: [
    {id: 1, 'title': '基金经理'},
    {id: 2, 'title': '研究员'},
    {id: 3, 'title': '联系人'},
    {id: -1, 'title': '其他'}
  ],
};
export default  list;



// WEBPACK FOOTER //
// ./src/assets/js/formList.js